import { atom } from "jotai";

export const getTokenAtom = atom<{ getToken: () => Promise<string | null> }>({
  getToken: () => Promise.resolve(null),
});
